import { CdkDrag, CdkDropList, DragDropModule } from '@angular/cdk/drag-drop';
import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';

const modules = [
	MatChipsModule,
	MatFormFieldModule,
	MatIconModule,
	MatInputModule,
	MatCardModule,
	MatButtonModule,
	MatCheckboxModule,
	MatRadioModule,
	MatToolbarModule,
	MatSelectModule,
	MatSidenavModule,
	MatListModule,
	MatGridListModule,
	MatAutocompleteModule,
	MatDialogModule,
	MatTableModule,
	MatMenuModule,
	MatPaginatorModule,
	MatSortModule,
	DragDropModule,
	CdkDropList,
	CdkDrag,
	MatTabsModule,
	MatProgressSpinnerModule,
	MatSlideToggleModule,
];

@NgModule({
	imports: modules,
	exports: modules,
})
export class MaterialModule {}
